// extracted by mini-css-extract-plugin
export default {"container":"CategorySelector_container__7I5V3","space":"CategorySelector_space__7D4PC","select":"CategorySelector_select__WDWmT","divider":"CategorySelector_divider__I8JP9"};